module.exports = __webpack_public_path__ + "2f60afc5abfa1e5c1314d106df5dbfec.svg";